import { runInAction, makeAutoObservable } from "mobx";

interface Obj {
  [key: string]: any;
}

class ErrorSubscription {
  errors: Obj = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  subscribe = ({ message, id }: { message: string, id: string | string[] }) => {

    

    if (typeof id == 'string')
      this.errors[id] = message
    else {
      for (let i = 0; i < id.length; i++) {
        this.errors[id[i]] = message;

      }
    }

  };

  unSubscribeAll = () => {
    this.errors = {}
  }
  // handleBack=()=>{
  //   runInAction(()=>{
  //     this.errors={}
  //   })
  // }

}

const errorSubscriptionStore = new ErrorSubscription()
export default errorSubscriptionStore;
